:host {
  display: block;
  box-sizing: border-box;
  --document-listing-top-margin: 0;
  --document-listing-top-margin-mobile: 0;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.range-tabs {
  width: 100%;
  height: 100%;
}

pes-document-listing .document-listing-container {
  background: transparent;
  box-sizing: border-box;
}

pes-document-listing .document-listing-container *,
pes-document-listing .document-listing-container *::before,
pes-document-listing .document-listing-container *::after {
  box-sizing: inherit;
}